import TbxComponent from 'tbxjs/component';
import Tbx from 'tbxjs';
// import components from "./components";


class UIComponent extends TbxComponent {
    empty() {
        while (this.element.firstChild) {
            this.element.removeChild(this.element.lastChild);
        }
    }

    append(element) {
        if (element instanceof UIComponent) {
            element = element.el();
        }
        this.element.appendChild(element);
        return this;
    }

    clone() {
        let clone = this.element.cloneNode(true);
        clone.querySelectorAll('[tbx-id]').forEach(element => {
            element.removeAttribute('tbx-id');
        });
        clone.removeAttribute('tbx-id');
        let component = Tbx.createComponent(clone);
        Tbx.createComponents(null, clone, component);
        Tbx.initQueued();
        return component;
    }

    on(eventName, callback) {
        let component = this;
        this.element.addEventListener(eventName, function (e) { e.component = component; callback.bind(this); callback(e) });
    }

    emit(eventName, detail, options = {}) {
        this.element.dispatchEvent(new CustomEvent(eventName, { detail, ...options }));
    }

    replaceClass(oldClass, newClass) {
        this.removeClass(oldClass);
        this.addClass(newClass);
    }

    hasAttr(name) {
        return this.element.hasAttribute(name);
    }

    hasNode(node) {
        return this.element.contains(node);
    }
}

export { UIComponent, Tbx };
export default UIComponent;
